<template>
  <div class="breadcrumb">
    <div style="float:left;width:300px;">{{level1}} <i class="el-icon-arrow-right"></i> {{level2}} <i class="el-icon-arrow-right" v-if="level3.length>0"></i> {{level3}}</div>
    <div style="float:right;width:200px;text-align: right;">服务器时间：<span id="server_time">{{time}}</span></div>

  </div>
</template>

<script>
  export default{
    name:'Breadcrumb',
    data(){
      return {
        level1:'主菜单',
        level2:'基础数据',
        level3:'',
        copyright:'',
        time:zyl.parse_time(new Date()),
        links:[
          {link:'/back/weigh/monitor',level1:'主菜单',level2:'过磅监控0',level3:''},
          {link:'/back/weigh/monitor1',level1:'主菜单',level2:'过磅监控1',level3:''},
          {link:'/back/weigh/monitor2',level1:'主菜单',level2:'过磅监控2',level3:''},
        ],
      }
    },
    methods:{
      fun_get_parent(_c){
        var _this = this;
        this.$store.state.menu.rows.forEach(n=>{
          if(n.levelCode.length!=3)return;
          if(!_c.levelCode.startsWith(n.levelCode))return;
          this.level2 = n.resourceName;
        });
      },
    },
    mounted() {
      var _this = this;
      if(this.$store.state.menu.rows<=0) this.$store.dispatch('reloadMenu')
      this.$store.state.menu.rows.forEach(n=>{
        if(n.url!=this.$route.fullPath) return;
        this.level3 = n.resourceName;
        this.fun_get_parent(n);
      });

      this.links.forEach(n=>{
        if(n.link!=_this.$route.fullPath) return;
        _this.level1=n.level1;
        _this.level2=n.level2;
      })

      if(window['server_timer']==undefined) window['server_timer']=setInterval(function(){
        if(document.getElementById('server_time')==null)return;
        let time = localStorage.getItem('server_time');
        if(time==undefined||time==null||time.length!=19) time = zyl.parse_time(new Date());
        let current = zyl.parse_time(new Date(new Date(time).getTime()+1000));
        document.getElementById('server_time').innerHTML = current;
        localStorage.setItem('server_time',current)
      },1000);
      // this.copyright = config.get().copyright;
    }
  }
</script>

<style>
</style>
